import React from 'react';
import { Box, BoxProps } from '@chakra-ui/react';

export const WhiteBox = React.memo(({ children, ...otherProps }: BoxProps) => {
  return (
    <Box
      borderRadius="2xl"
      background="rgba(255, 255, 255, 0.382)"
      width="100%"
      maxWidth={970}
      {...otherProps}
    >
      {children}
    </Box>
  );
});
